<h2 class="text-3xl font-semibold text-center text-gray-800 mb-3 uppercase">Descarga de facturas</h2>

<div class="max-w-2xl mx-auto p-6 bg-white shadow-md rounded-lg">
    <form (ngSubmit)="onSubmit()" [formGroup]="auxForm" class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
            <h5 class="text-xl font-semibold mb-2">Agregar fecha:</h5>
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Fecha</mat-label>
                <mat-select placeholder="Seleccionar formato de fecha" [(value)]="dateFormat"
                    (selectionChange)="onDateFormatChange()">
                    <mat-option value="year">Año</mat-option>
                    <mat-option value="month">Año y Mes</mat-option>
                    <mat-option value="date">Fecha Completa</mat-option>
                </mat-select>
            </mat-form-field>


            <mat-form-field appearance="fill" class="w-full" *ngIf="dateFormat === 'year'">
                <mat-label>Año</mat-label>
                <input (change)="onDateSelected($event)" matInput type="number" formControlName="date"
                    placeholder="Ingrese el año" [min]="1900" [max]="currentYear">
            </mat-form-field>



            <!-- <mat-form-field appearance="fill" class="w-full" *ngIf="dateFormat === 'month'">
                <mat-label>Año y Mes</mat-label>
                <input matInput [matDatepicker]="monthPicker" formControlName="date" [max]="maxDate">
                <mat-datepicker-toggle matSuffix [for]="monthPicker"></mat-datepicker-toggle>
                <mat-datepicker #monthPicker startView="multi-year" (monthSelected)="separateDate($event, monthPicker)"
                    panelClass="month-picker"></mat-datepicker>
            </mat-form-field> -->
            <mat-form-field *ngIf="dateFormat === 'month'">
                <mat-label>MM/YYYY</mat-label>
                <input matInput [matDatepicker]="dp" formControlName="date" placeholder="MM/YYYY" [max]="maxDate">
                <mat-datepicker-toggle matIconSuffix [for]="dp"></mat-datepicker-toggle>
                <mat-datepicker #dp startView="multi-year" (monthSelected)="setMonthAndYear($event, dp)"
                    panelClass="example-month-picker">
                </mat-datepicker>
            </mat-form-field>





            <mat-form-field appearance="fill" class="w-full" *ngIf="dateFormat === 'date'">
                <mat-label>Fecha</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="date"
                    (dateChange)="onDateSelected($event,picker)" [max]="maxDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>


        </div>

        <!-- <div>
            <h5 class="text-xl font-semibold mb-2">Agregar proveedor:</h5>
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Proveedor</mat-label>
                <input matInput formControlName="provider" >
            </mat-form-field>
        </div> -->

        <div [ngStyle]="{ display: dateFormat !== 'date' ? 'none' : 'block' }">
            <h5 class="text-xl font-semibold mb-2 whitespace-nowrap">Agregar código de cliente:</h5>
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>Código de Cliente</mat-label>
                <input matInput formControlName="clientCode">
            </mat-form-field>
        </div>

        <div>
            <h5 class="text-xl font-semibold mb-2">Agregar CIF:</h5>
            <mat-form-field appearance="fill" class="w-full">
                <mat-label>CIF</mat-label>
                <input matInput formControlName="cif" required>
                <mat-error *ngIf="auxForm.controls['cif'].invalid && auxForm.controls['cif'].touched">El CIF es
                    requerido.</mat-error>
            </mat-form-field>
        </div>
        <div class="md:col-span-2">
            <button
                class="w-full mt-4 px-4 py-2 bg-orange-500 text-white rounded-md hover:bg-orange-600 transition-colors duration-300"
                type="submit">Buscar Factura</button>
        </div>
    </form>
</div>
<div *ngIf="isLoading" class="absolute inset-0 flex items-center justify-center bg-white opacity-75">
    <svg class="animate-spin h-5 w-5 text-orange-500 ml-2" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
        </path>
    </svg>
</div>
<table *ngIf="!isLoading && isSearch && bills.length > 0" class="w-full table-fixed mt-3">
    <thead class="bg-orange-500 text-white">
        <tr>
            <th class="px-3 py-2 border-b-2 border-orange-600 text-sm">Nombre de Archivo</th>
            <th class="px-3 py-2 border-b-2 border-orange-600 text-sm">Fecha</th>
            <th class="px-3 py-2 border-b-2 border-orange-600 text-sm">Cod.Cliente</th>
            <th class="px-3 py-2 border-b-2 border-orange-600 text-sm">CIF</th>
            <th class="px-3 py-2 border-b-2 border-orange-600 text-sm">Acciones</th>

        </tr>
    </thead>
    <tbody class="bg-white">
        <tr *ngFor="let result of bills; even as isEven" class="hover:bg-gray-200 transition duration-150 ease-in-out">

            <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ result.fileName || '-' }}</td>
            <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ result.date }}</td>
            <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ result.clientCode || '-' }}</td>
            <td class="px-5 py-5 border-b border-gray-200 text-center align-middle">{{ result.cif || '-' }}</td>
            <td class="px-5 py-5 border-b border-gray-200 text-center align-middle"><mat-icon class="cursor-pointer" (click)="downloadBill(result)">file_download</mat-icon></td>

        </tr>
    </tbody>
</table>
<div *ngIf="bills.length === 0 && isSearch" class="bg-white shadow-md rounded-lg mt-5 p-7">
    <h1 class="text-2xl font-bold text-center text-gray-600">No se encontraron facturas.</h1>
</div>